import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { createRoot } from 'react-dom/client'
import { Routes } from './Routes'
import { AuthProvider } from './contexts/useAuthUser'
import { MyInboxesProvider } from './contexts/MyInboxesContext'
import { useIsMobile } from './hooks/useIsMobile'
import './globals.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 30 * 60 * 1000, // 30 minutes (formerly cacheTime)
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

const container = document.getElementById('app')
if (!container) {
  throw Error('No #app in document.')
}

const RootApp = () => {
  const isMobile = useIsMobile()

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <MyInboxesProvider>
          <ToastContainer position={isMobile ? 'bottom-center' : 'top-right'} />
          <Routes />
        </MyInboxesProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}

const root = createRoot(container)
root.render(<RootApp />)
